import React, { useMemo } from 'react'
import SectionContainer from '../../../../../Homepage/SectionContainer'
import BreadCrumb from '../../../../../component/BreadCrumb/BreadCrumb'
import FourP1 from "../../../../svg/FourP1.svg"
import bvm1 from "../../../../svg/bvm1.svg"
import bvm2 from "../../../../svg/bvm2.svg"
import ivm1 from "../../../../svg/ivm1.svg"
import ivm2 from "../../../../svg/ivm2.svg"
import ivm3 from "../../../../svg/ivm3.svg"
import pe1 from "../../../../svg/pe1.svg"
import pe2 from "../../../../svg/pe2.svg"
import va1 from "../../../../svg/va1.svg"
import sc1 from "../../../../svg/sc1.svg"
import sc2 from "../../../../svg/sc2.svg"
import bc from "../../../../svg/bc.svg"
import cf1 from "../../../../svg/cf1.svg"
import cf2 from "../../../../svg/cf2.svg"
import na1 from "../../../../svg/na1.svg"
import na2 from "../../../../svg/na2.svg"
import brandvisualmark1 from "../../../../../assets/kangaroo/brandvisualmark1.jpg"
import brandvisualmark2 from "../../../../../assets/kangaroo/brandvisualmark2.jpg"
import productservice1 from "../../../../../assets/kangaroo/productService1.jpg"
import productservice2 from "../../../../../assets/kangaroo/productService2.jpg"
import productservice3 from "../../../../../assets/kangaroo/productService3.jpg"
import productservice4 from "../../../../../assets/kangaroo/productService4.jpg"
import productservice5 from "../../../../../assets/kangaroo/productService5.jpg"
import productservice6 from "../../../../../assets/kangaroo/productService6.jpg"
import identitycorporate1 from "../../../../../assets/kangaroo/identityCorportate1.jpg"
import identitycorporate2 from "../../../../../assets/kangaroo/identityCorportate2.jpg"
import identitycorporate3 from "../../../../../assets/kangaroo/identityCorportate3.jpg"
import identitycorporate4 from "../../../../../assets/kangaroo/identityCorportate4.jpg"
import identitycorporate5 from "../../../../../assets/kangaroo/identityCorportate5.jpg"
import identitycorporate6 from "../../../../../assets/kangaroo/identityCorportate6.jpg"
import identitycorporate7 from "../../../../../assets/kangaroo/identityCorportate7.jpg"
import identitymaterial1 from "../../../../../assets/kangaroo/identityMaterial1.jpg"
import identitymaterial2 from "../../../../../assets/kangaroo/identityMaterial2.jpg"
import identitymaterial3 from "../../../../../assets/kangaroo/identityMaterial3.jpg"
import identitymaterial4 from "../../../../../assets/kangaroo/identityMaterial4.jpg"
import identitymaterial5 from "../../../../../assets/kangaroo/identityMaterial5.jpg"
import identitymaterial6 from "../../../../../assets/kangaroo/identityMaterial6.jpg"
import identitymaterial7 from "../../../../../assets/kangaroo/identityMaterial7.jpg"
import identitymaterial8 from "../../../../../assets/kangaroo/identityMaterial8.jpg"
import identitymaterial9 from "../../../../../assets/kangaroo/identityMaterial9.jpg"
import identitymaterial10 from "../../../../../assets/kangaroo/identityMaterial10.jpg"
import identitymaterial11 from "../../../../../assets/kangaroo/identityMaterial11.jpg"
import identitymaterial12 from "../../../../../assets/kangaroo/identityMaterial12.jpg"
import identitymaterial13 from "../../../../../assets/kangaroo/identityMaterial13.jpg"
import identitymaterial14 from "../../../../../assets/kangaroo/identityMaterial14.jpg"
import identitymaterial15 from "../../../../../assets/kangaroo/identityMaterial15.jpg"

import marketingImg1 from "../../../../../assets/kangaroo/corporateMImg1.jpg"
import marketingImg2 from "../../../../../assets/kangaroo/corporateMImg2.jpg"
import marketingImg3 from "../../../../../assets/kangaroo/corporateMImg3.jpg"
import marketingImg4 from "../../../../../assets/kangaroo/corporateMImg4.jpg"
import marketingImg5 from "../../../../../assets/kangaroo/corporateMImg5.jpg"
import marketingImg6 from "../../../../../assets/kangaroo/corporateMImg6.jpg"
import marketingImg7 from "../../../../../assets/kangaroo/corporateMImg7.jpg"
import marketingImg8 from "../../../../../assets/kangaroo/corporateMImg8.jpg"
import marketingImg9 from "../../../../../assets/kangaroo/corporateMImg9.jpg"
import marketingImg10 from "../../../../../assets/kangaroo/corporateMImg10.jpg"
import marketingImg11 from "../../../../../assets/kangaroo/corporateMImg11.jpg"
import marketingImg12 from "../../../../../assets/kangaroo/corporateMImg12.jpg"
import marketingImg13 from "../../../../../assets/kangaroo/corporateMImg13.jpg"
import marketingImg14 from "../../../../../assets/kangaroo/corporateMImg14.jpg"
import marketingImg15 from "../../../../../assets/kangaroo/corporateMImg15.jpg"
import marketingImg16 from "../../../../../assets/kangaroo/corporateMImg16.jpg"
import marketingImg17 from "../../../../../assets/kangaroo/corporateMImg17.jpg"
import marketingImg18 from "../../../../../assets/kangaroo/corporateMImg18.jpg"
// import marketingDownload1 from "../../../../../assets/downloads/corporateMaterial1.ai"
// import marketingDownload2 from "../../../../../assets/downloads/corporateMaterial2.ai"
// import marketingDownload3 from "../../../../../assets/downloads/corporateMaterial3.ai"
// import marketingDownload4 from "../../../../../assets/downloads/corporateMaterial4.ai"
// import marketingDownload5 from "../../../../../assets/downloads/corporateMaterial5.ai"
// import marketingDownload6 from "../../../../../assets/downloads/corporateMaterial6.ai"
// import marketingDownload7 from "../../../../../assets/downloads/corporateMaterial7.ai"
// import marketingDownload8 from "../../../../../assets/downloads/corporateMaterial8.ai"
// import marketingDownload9 from "../../../../../assets/downloads/corporateMaterial9.jpg"
// import marketingDownload10 from "../../../../../assets/downloads/corporateMaterial10.ai"
// import marketingDownload11 from "../../../../../assets/downloads/corporateMaterial11.jpg"
// import marketingDownload12 from "../../../../../assets/downloads/corporateMaterial12.ai"
// import marketingDownload13 from "../../../../../assets/downloads/corporateMaterial13.ai"
// import marketingDownload14 from "../../../../../assets/downloads/corporateMaterial14.ai"
// import marketingDownload15 from "../../../../../assets/downloads/corporateMaterial15.ai"
// import marketingDownload16 from "../../../../../assets/downloads/corporateMaterial16.ai"
// import marketingDownload17 from "../../../../../assets/downloads/corporateMaterial17.ai"
// import marketingDownload18 from "../../../../../assets/downloads/corporateMaterial18.ai"


// import va2 from "../../../../svg/va2.svg"
// import va3 from "../../../../svg/va3.svg"
import { Col, Row } from 'reactstrap'

const Identity = () => {
    const text = `<span class="fw-bold fs-5">The 4Ps: Building the Foundation of KEFEVS’s Brand Identity</span>
At the heart of Kangaroo Education Foundation Education & Visa Services’s philosophy lies the 4Ps-People, Process, Product, and Progress. These four pillars define our vision, guide our operations, and inspire the visual and structural elements of our Brand Identity Guidelines.


<span class="fw-bold fs-5">The Path to Excellence</span>
Our brand identity is symbolized by a forward-moving pathway, created by the interplay of three elements-People, Process, and Product-culminating in Progress. This pathway embodies KEFEVS's commitment to growth, innovation, and excellence. Every communication material-whether Brand Communications, Sales Communications, Corporate Communications, or Corporate Materials-is designed using this pathway motif, aligning with our 4Ps philosophy.`
    const text2 = `1. People:
People are the cornerstone of KEFEVS’s success. We prioritize the empowerment of our employees by nurturing their growth, while also providing students with transparent, personalized, and effective guidance for their study-abroad aspirations. At KEFEVS, we believe that thriving people drive thriving results.

2. Process:
Well-defined processes ensure consistency and quality. At KEFEVS, we implement structured operations-from counseling to application handling and institutional collaborations-creating a cohesive system that ensures excellent results. A strong process transforms individual efforts into collective success.

3. Product:
Our product is the value we offer-be it through partnerships with leading global institutions, expert test preparation, or bespoke counseling services. KEFEVS’s expanding academic network ensures that we stay ahead of industry trends, offering students unparalleled opportunities to achieve their dreams.

4. Progress:
Progress is the ultimate outcome when People, Process, and Product harmoniously align. KEFEVS focuses on continuous improvement, innovation, and adaptability, fostering a culture where dreams and careers flourish. Progress is not just company growth; it is the advancement of our students and the fulfillment of their ambitions.

`
    const brandText = `
The Brand Visual Mark is a design structure created for use when the focus is on the logo and image only. It combines the KEFEVS Secondary Logo with a visually impactful image across various digital and print materials. This structure allows for the seamless integration of a prominent image, helping to capture attention while ensuring consistent brand recognition through the Secondary Logo. The Brand Visual Mark is intended for materials where the visual narrative is key, and the logo serves as a supporting element to reinforce the brand identity.
1.Designated space for the KEFEVS Secondary Logo.
2.Space where the image will be overlaid with a gradient using two colors from the primary or secondary color palette.
3.Area for placing a key image to complement the brand’s visual message.`

    const brandText2 = `The Brand Visual Mark with Messaging is a design structure used when both the logo and a key message need to be presented together with a visually impactful image. It combines the KEFEVS Secondary Logo with a striking image and accompanying text. The content is positioned above the gradient area, ensuring that the messaging is clear and aligned with the visual narrative. This structure integrates both the logo and the message seamlessly, enabling a cohesive and strong brand presence across both digital and print materials.
1.Designated space for the KEFEVS Secondary Logo.
2.Space where the image will be overlaid with a gradient using two colors from the primary or secondary color palette.
3.Area for placing a key image to complement the brand’s visual message.
4.Content area above the gradient where the key messaging will be displayed.`

    const brandVisualMarkData = [
        {
            id: 1,
            title: "Brand Visual Mark",
            image: bvm1,
            text: brandText,
            bottomImage: brandvisualmark1
        },
        {
            id: 2,
            title: "Brand Visual Mark with Messaging",
            image: bvm2,
            text: brandText2,
            bottomImage: brandvisualmark2
        },
    ];

    const productService = `Product, Services & Partnership Showcase-1 is one of three designs created to showcase KEFEVS’s products, services, partner institutions’ offerings, and the products and services of other KEFEVS partners. This design structure provides a dynamic and cohesive framework for digital and print materials.
1.Designated space for the KEFEVS Secondary Logo.
2.Area for placing a key image to complement the brand’s visual message.
3.Designated white space for key messaging.
4.Space where the image will be overlaid with a gradient using two colors from the primary or secondary color palette.`

    const productService2 = `Product, Services & Partnership Showcase-2 is one of three designs created to showcase KEFEVS’s products, services, partner institutions’ offerings, and the products and services of other KEFEVS partners. This design structure provides a dynamic and cohesive framework for digital and print materials.
1.Designated space for the KEFEVS Secondary Logo.
2.Designated white space for key messaging.
3.Area for placing a key image to complement the brand’s visual message.
4.Space where the image will be overlaid with a gradient using two colors from the primary or secondary color palette.`

    const productService3 = `
Product, Services & Partnership Showcase-3 is one of three designs created to showcase KEFEVS’s products, services, partner institutions’ offerings, and the products and services of other KEFEVS partners. This design structure provides a dynamic and cohesive framework for digital and print materials.
1.Designated space for the KEFEVS Secondary Logo.
2.Area for placing a key image to complement the brand’s visual message.
3.Designated space for partner/product Logo.
4.Space where the image will be overlaid with a gradient using two colors from the primary or secondary color palette, with key messaging space in front (if required).`

    const programEvent1 = `The Program, Event & Fair-1 design structure is one of two designs intended for events, fairs, and seminars where large groups of students, parents, or service seekers of KEFEVS will gather. This design structure emphasizes clear white space, allowing flexibility for content and images related to the event. The layout is designed to accommodate various types of information, with the Secondary Logo placed at the bottom. The upper portion of the design offers more usable space for showcasing event-specific details, providing room for creative flexibility in the design.
1.Designated space for the KEFEVS Secondary Logo.
2.Space for content, images, mnemonics, and other event-related materials.`

    const programEvent2 = `The Program, Event & Fair-2 design structure is one of two designs intended for events, fairs, and seminars where large groups of students, parents, or service seekers of KEFEVS will gather. This design structure emphasizes clear white space, allowing flexibility for content and images related to the event. The layout is designed to accommodate various types of information, with the Secondary Logo placed at thetop. The below portion of the design offers more usable space for showcasing event-specific details, providing room for creative flexibility in the design.
1.Designated space for the KEFEVS Secondary Logo.
2.Space for content, images, mnemonics, and other event-related materials.`

    const visaAnnonce1 = `The Visa Achievement Announcement design structure is created to highlight students who have successfully received their visa for any destination processed by KEFEVS. This design emphasizes clear space to prominently feature the student’s picture, celebrating their success.
1.Designated space for the KEFEVS Secondary Logo.
2.Dedicated space to showcase the student's picture.
3.Space for text content, including a congratulatory message and the destination where the visa was granted.
4.Two-color gradient space for displaying the student's full name, course, institution, and program details.`

    const IdentityVisualMarkData = [
        {
            id: 1,
            title: "Product, Services & Partnership Showcase-1",
            image: ivm1,
            text: productService,
            bottomImage: productservice1
        },
        {
            id: 2,
            title: "Product, Services & Partnership Showcase-2",
            image: ivm2,
            text: productService2,
            bottomImage: productservice2
        },
        {
            id: 3,
            title: "Product, Services & Partnership Showcase-3",
            image: ivm3,
            text: productService3,
            bottomImage: productservice3
        },
        {
            id: 4,
            title: "Program, Event & Fair-1",
            image: pe1,
            text: programEvent1,
            bottomImage: productservice4
        },
        {
            id: 5,
            title: "Program, Event & Fair-2",
            image: pe2,
            text: programEvent2,
            bottomImage: productservice5
        },
        {
            id: 6,
            title: "Visa Achievement Announcement",
            image: va1,
            text: visaAnnonce1,
            bottomImage: productservice6
        },
    ];

    const seasonalCelebration1 = `The Seasonal Celebration-1 design structure is created for festive occasions, celebrations, and events where KEFEVS wishes to communicate corporate greetings to its clients. It features a dedicated space at the bottom for KEFEVS's Primary Logo, with the upper white space left flexible for design elements that can be tailored to suit the specific occasion. This is one of the two design options available for such communications.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.`

    const seasonalCelebration2 = `The Seasonal Celebration-2 design structure is similar to Seasonal Celebration-1, with the key difference being the addition of a two-color gradient area. This gradient space allows for the placement of pictures, content, or other design elements, providing greater flexibility in visual presentation while maintaining a festive, occasion-specific theme.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.
✋ Any type of gradient-Radial, Freeform, or Linear-can be used within the two-color gradient area to enhance the design.`

    const birthdayCelebration = `The Birthday Celebration design structure is created for social media posts celebrating the birthdays of KEFEVS team members. It features a dedicated space for placing the photo of the birthday celebrant, along with areas for including their name, a personalized birthday message, and KEFEVS branding elements. The design ensures a professional layout, making the celebratory posts visually appealing and consistent with KEFEVS’s brand identity.
1.Designated space for the KEFEVS Primary Logo.
2.Dedicated space to showcase a personalized birthday message, including the name of the birthday celebrant.
3.Dedicated space for the "Happy Birthday" text.
4.Dedicated space for placing the photo of the birthday celebrant`

    const congratulationsFelicitation1 = `The Congratulations & Felicitation-1 design structure is one of two available options created to convey KEFEVS’s corporate congratulations and felicitations to partner institutions, vendors, and other stakeholders for their achievements, milestones, or special occasions. It includes a dedicated space at the bottom for KEFEVS's Primary Logo, with the upper white space designed to remain flexible for incorporating tailored design elements suited to the specific message.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.`

    const congratulationsFelicitation2 = `The Congratulations & Felicitation-2 design structure builds on the first option, with the key difference being the inclusion of a two-color gradient area. This gradient space provides added flexibility, allowing for the placement of pictures, content, or other design elements while maintaining KEFEVS’s branding consistency. It is designed to enhance visual appeal and adaptability for communicating corporate congratulations and felicitations to partner institutions, vendors, and other stakeholders.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.
✋ Any type of gradient-Radial, Freeform, or Linear-can be used within the two-color gradient area to enhance the design.`

    const noticeAnnouncement1 = `The Notice & Announcement-1 design structure is one of two options created for sharing KEFEVS's official notices and announcements. It features a dedicated space at the bottom for KEFEVS's Primary Logo, while the upper white space is designed to be flexible, allowing for the inclusion of tailored design elements to suit the specific message. This structure ensures clarity and consistency in KEFEVS’s corporate communication materials.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.`

    const noticeAnnouncement2 = `The Notice & Announcement-2 design structure is one of two options created for sharing KEFEVS's official notices and announcements. While it retains the same layout as Notice & Announcement-1, it features KEFEVS's Primary Purple Color in place of the white space. This Purple Color adds visual depth and allows for the inclusion of tailored design elements to suit the specific message, ensuring a vibrant and dynamic presentation.
1.Designated space for the KEFEVS Primary Logo.
2.Space for content, images, and other materials related to the occasion.`

    const IdentityCorporateData = [
        {
            id: 1,
            title: "Seasonal Celebration-1",
            image: sc1,
            text: seasonalCelebration1,
            bottomImage: identitycorporate1
        },
        {
            id: 2,
            title: "Seasonal Celebration-2",
            image: sc2,
            text: seasonalCelebration2,
            bottomImage: identitycorporate2
        },
        {
            id: 3,
            title: "Birthday Celebration",
            image: bc,
            text: birthdayCelebration,
            bottomImage: identitycorporate3
        },
        {
            id: 4,
            title: "Congratulations & Felicitation-1",
            image: cf1,
            text: congratulationsFelicitation1,
            bottomImage: identitycorporate4
        },
        {
            id: 5,
            title: "Congratulations & Felicitation-2",
            image: cf2,
            text: congratulationsFelicitation2,
            bottomImage: identitycorporate5
        },
        {
            id: 6,
            title: "Notice & Announcement-1",
            image: na1,
            text: noticeAnnouncement1,
            bottomImage: identitycorporate6
        },
        {
            id: 7,
            title: "Notice & Announcement-2",
            image: na2,
            text: noticeAnnouncement2,
            bottomImage: identitycorporate7
        },
    ];

    const IdentityMaterial = [
        {
            id: 1,
            title: "Business Card",
            image: identitymaterial1
        },
        {
            id: 2,
            title: "Identity Card",
            image: identitymaterial2
        },
        {
            id: 3,
            title: "Letterhead",
            image: identitymaterial3
        },

        {
            id: 4,
            title: "Envelope",
            image: identitymaterial4
        },
        {
            id: 5,
            title: "Certificate",
            image: identitymaterial5
        },
        {
            id: 6,
            title: "Presentation Frame",
            image: identitymaterial6
        },
        {
            id: 7,
            title: "Puclication Cover",
            image: identitymaterial7
        },
        {
            id: 8,
            title: "Notepad",
            image: identitymaterial8
        },
        {
            id: 9,
            title: "Signage",
            image: identitymaterial9
        },
        {
            id: 10,
            title: "In-House Activities",
            image: identitymaterial10
        },
        {
            id: 11,
            title: "Photo Frame",
            image: identitymaterial11
        },
        {
            id: 12,
            title: "T-Shirt 1",
            image: identitymaterial12
        },
        {
            id: 13,
            title: "T-Shirt 2",
            image: identitymaterial13
        },
        {
            id: 14,
            title: "Water Bottle",
            image: identitymaterial14
        },
        {
            id: 15,
            title: "Mug",
            image: identitymaterial15
        },
        {
            id: 16,
            title: "Travel Mug",
            image: identitymaterial14
        },
        {
            id: 17,
            title: "Vaccum Flask",
            image: identitymaterial14
        },
        {
            id: 18,
            title: "Backpack",
            image: identitymaterial14
        },

    ]

    const marketingMaterialData = useMemo(() => [
        {
            id: 1,
            title: "Business Card",
            image: marketingImg1,

        },
        {
            id: 2,
            title: "Identity Card",
            image: marketingImg2,

        },
        {
            id: 3,
            title: "Letterhead",
            image: marketingImg3,

        },
        {
            id: 4,
            title: "Envelope",
            image: marketingImg4,

        },
        {
            id: 5,
            title: "Certificate",
            image: marketingImg5,

        },
        {
            id: 6,
            title: "Presentation Frame",
            image: marketingImg6,

        },
        {
            id: 7,
            title: "Publication Cover",
            image: marketingImg7,

        },
        {
            id: 8,
            title: "Notepad",
            image: marketingImg8,

        },
        {
            id: 9,
            title: "Signage",
            image: marketingImg9,

        },
        {
            id: 10,
            title: "In-House Activity",
            image: marketingImg10,

        },
        {
            id: 11,
            title: "Photo Frame",
            image: marketingImg11,

        },
        {
            id: 12,
            title: "T-Shirt 1",
            image: marketingImg12,

        },
        {
            id: 13,
            title: "T-Shirt 2",
            image: marketingImg13,

        },
        {
            id: 14,
            title: "Water Bottle",
            image: marketingImg14,

        },
        {
            id: 15,
            title: "Mug",
            image: marketingImg15,

        },
        {
            id: 16,
            title: "Travel Mug",
            image: marketingImg16,

        },
        {
            id: 17,
            title: "Vaccum Flask",
            image: marketingImg17,

        },
        {
            id: 18,
            title: "Backpack",
            image: marketingImg18,

        },

    ], []);




    return (
        <SectionContainer>
            <BreadCrumb items={[
                { title: "HOME", link: "/" },
                { title: "BRAND IDENTITY GUIDELINE", link: "/brand-identity-guideline" },
                { title: "IDENTITY" },
            ]} instituition={false} className="" />

            <h1 className="font-level-1" style={{ marginBottom: "5rem", color: "#D60F84" }}>IDENTITY.</h1>
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">IDENTITY.</span>ELEMENT</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            <h1 className="country-paragraph-text">The 4Ps</h1>
            <Row>
                <Col lg={6} md={12}>
                    <img src={FourP1} alt="" />

                </Col>
                <Col></Col>
                <Col lg={5} md={12}>
                    <p
                        className="country-paragraph-text"
                        style={{ whiteSpace: "pre-line", marginTop: "5rem" }}
                        dangerouslySetInnerHTML={{ __html: text }}
                    ></p>
                </Col>
            </Row>

            <h1 className="country-paragraph-text fw-bold fs-5 mt-5 mb-4">Understanding KEF's 4Ps</h1>
            <p
                className="country-paragraph-text"
                style={{ whiteSpace: "pre-line", }}
                dangerouslySetInnerHTML={{ __html: text2 }}
            ></p>
            <p className='country-paragraph-text' style={{ marginBottom: "10rem" }}><span className='fw-bold fs-5'>The Connection to Brand Identity</span> <br />
                These 4Ps are not just principles but also the foundation of our Brand Identity Guidelines. By integrating these elements into the design of the forward-moving arrow, KEFEVS reinforces its commitment to excellence. This arrow serves as a visual representation of our unified approach to empowering people, creating robust processes, delivering exceptional products, and driving progress. Through this alignment, KEFEVS’s brand identity reflects our core philosophy, ensuring a consistent and impactful message across all mediums.</p>
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">IDENTITY.</span> BRAND COMMUNICATION STRUCTURE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {brandVisualMarkData.map((data, index) => (

                <React.Fragment key={data.id}>
                    <h1 className='country-paragraph-text'>{data.title}</h1>
                    <Row>
                        <Col lg={6} md={12}>
                            <img src={data.image} alt="" />
                        </Col>
                        <Col></Col>
                        <Col lg={5} md={12}>
                            <div
                                className="country-paragraph-text"
                                style={{ whiteSpace: "pre-line", marginTop: "5rem" }}
                                dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                            />
                        </Col>
                    </Row>
                    <img src={data.bottomImage} alt="" className="mt-5" style={{ width: "100%" }} />

                    <hr className="line" style={{ marginBottom: index === brandVisualMarkData.length - 1 ? "5rem" : "5rem", marginTop: "5rem", opacity: index === brandVisualMarkData.length - 1 ? 0 : 0.25 }} />
                </React.Fragment>
            ))}
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">IDENTITY.</span> SALES COMMUNICATION STRUCTURE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />

            {IdentityVisualMarkData.map((data, index) => (
                <React.Fragment key={data.id}>
                    <h1 className='country-paragraph-text'>{data.title}</h1>
                    <Row>
                        <Col lg={6} md={12}>
                            <img src={data.image} alt="" />
                        </Col>
                        <Col></Col>
                        <Col lg={5} md={12}>
                            <p
                                className="country-paragraph-text"
                                style={{ whiteSpace: "pre-line", marginTop: "2rem" }}
                                dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                            ></p>
                        </Col>
                    </Row>
                    <img src={data.bottomImage} alt="" className="mt-5" style={{ width: "100%" }} />
                    <hr className="line" style={{ marginBottom: index === IdentityVisualMarkData.length - 1 ? "5rem" : "5rem", marginTop: "5rem", opacity: index === IdentityVisualMarkData.length - 1 ? 0 : 0.25 }} />
                </React.Fragment>
            ))}
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">IDENTITY.</span> CORPORATE COMMUNICATION STRUCTURE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />

            {IdentityCorporateData.map((data, index) => (
                <React.Fragment key={data.id}>
                    <h1 className='country-paragraph-text'>{data.title}</h1>
                    <Row>
                        <Col lg={6} md={12}>
                            <img src={data.image} alt="" />
                        </Col>
                        <Col></Col>
                        <Col lg={5} md={12}>
                            <p
                                className="country-paragraph-text"
                                style={{ whiteSpace: "pre-line", marginTop: "2rem" }}
                                dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                            ></p>
                        </Col>
                    </Row>
                    <img src={data.bottomImage} alt="" className="mt-5" style={{ width: "100%" }} />
                    <hr className="line" style={{ marginBottom: index === IdentityCorporateData.length - 1 ? "5rem" : "5rem", marginTop: "5rem", opacity: index === IdentityCorporateData.length - 1 ? 0 : 0.25 }} />

                </React.Fragment>
            ))}

            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">IDENTITY.</span> CORPORATE MATERIALS STRUCTURE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />

            {marketingMaterialData.map((item, index) => (
                <div key={item.id} style={{ marginBottom: "30px" }}>

                    <h3 className='country-paragraph-text'>{item.title}</h3>

                    <Row>
                        <Col lg={item.isFull ? 12 : 12} md={item.isFull ? 12 : 12} sm={12}>
                            <img src={item.image} alt={item.title} className="img-fluid w-100" loading="lazy" />
                        </Col>
                    </Row>


                    <hr className="line" style={{ marginBottom: index === marketingMaterialData.length - 1 ? "5rem" : "5rem", marginTop: "5rem", opacity: index === marketingMaterialData.length - 1 ? 0 : 0.25 }} />

                </div>
            ))}



        </SectionContainer>
    )
}

export default Identity